<template>
  <el-dialog
    :title="dialogTitle"
    :visible="visible"
    width="80%"
    :close-on-click-modal="false"
    class="page-dialog center-dialog"
    @update:visible="val => emitUpdateVisible(val)"
    @closed="handleClosed"
  >
    <div class="dialog-content">
      <div class="page-content page-search" style="padding: 0 20px">
        <el-form size="mini" :model="searchForm" label-position="right" class="search-form-flex" @submit.native.prevent>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="游戏名称">
                <el-input v-model="searchForm.game_name" placeholder="请输入游戏名称" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="游戏厂商">
                <el-input v-model="searchForm.game_provider" placeholder="请输入游戏厂商" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="text-align: right">
              <el-button type="primary" size="mini" :loading="loading" @click="handleSearch">筛选</el-button>
              <el-button size="mini" :disabled="loading" @click="handleReset">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="page-content">
        <div class="transfer-toolbar">
          <div class="toolbar-left">
            <span class="tip">已选择 {{ selectedKeys.length }} 个游戏</span>
          </div>
          <div class="toolbar-right">
            <el-button type="text" size="mini" :disabled="selectedKeys.length === 0" @click="clearSelected">清空已选</el-button>
          </div>
        </div>

        <div class="table-transfer">
          <div class="panel">
            <div class="panel-title">全部游戏</div>
            <el-table ref="leftTableRef" size="mini" :data="availableRows" border stripe fit height="420" @selection-change="handleLeftSelectionChange">
              <el-table-column :resizable="false" type="selection" width="40" align="center" :selectable="isSelectableLeftRow" />
              <el-table-column :resizable="false" prop="game_name" label="游戏名称" min-width="180">
                <template slot-scope="scope">
                  <div class="game-name-cell">
                    <el-tag v-if="isRelatedRow(scope.row)" class="related-inline-mark" type="info" size="mini">已关联</el-tag>
                    <span>{{ scope.row.game_name || '-' }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :resizable="false" prop="game_provider" label="游戏厂商" min-width="110" />
              <el-table-column :resizable="false" prop="game_type" label="游戏类型" width="100" />
              <el-table-column :resizable="false" prop="tags" label="游戏标签" min-width="100">
                <template slot-scope="scope">
                  {{ formatTagsDisplay(scope.row.tags) }}
                </template>
              </el-table-column>
              <el-table-column :resizable="false" prop="status" label="状态" width="90" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">{{ formatStatus(scope.row.status) }}</el-tag>
                </template>
              </el-table-column>
            </el-table>

            <div class="pagination-container">
              <el-pagination
                :current-page="pagination.currentPage"
                :page-size="pagination.pageSize"
                :page-sizes="[10, 20, 50, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>

          <div class="actions">
            <el-button type="primary" size="mini" :disabled="leftSelectedKeys.length === 0" @click="addSelected"> 选择 </el-button>
            <el-button size="mini" :disabled="rightSelectedKeys.length === 0" @click="removeSelected"> 移除 </el-button>
          </div>

          <div class="panel">
            <div class="panel-title">本次新增</div>
            <el-table ref="rightTableRef" size="mini" :data="selectedRows" border stripe fit height="420" @selection-change="handleRightSelectionChange">
              <el-table-column :resizable="false" type="selection" width="40" align="center" />
              <el-table-column :resizable="false" prop="game_name" label="游戏名称" min-width="160" />
              <el-table-column :resizable="false" prop="game_provider" label="游戏厂商" min-width="110" />
              <el-table-column :resizable="false" prop="game_type" label="游戏类型" width="100" />
              <el-table-column :resizable="false" prop="tags" label="游戏标签" min-width="100">
                <template slot-scope="scope">
                  {{ formatTagsDisplay(scope.row.tags) }}
                </template>
              </el-table-column>
              <el-table-column :resizable="false" prop="status" label="状态" width="90" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">{{ formatStatus(scope.row.status) }}</el-tag>
                </template>
              </el-table-column>
            </el-table>
            <div v-if="relatedLoading" class="right-loading-tip">正在加载已关联游戏...</div>
          </div>
        </div>
      </div>
    </div>

    <template slot="footer">
      <el-button size="small" @click="emitUpdateVisible(false)">取消</el-button>
      <el-button type="primary" size="small" :loading="submitLoading" @click="handleConfirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { computed, reactive, ref, watch, getCurrentInstance } from 'vue'
import { listGameItems, updateGameItemTags } from '@/api/gameManage/gameList.js'

const DEFAULT_PAGE_SIZE = 20
const RELATED_PAGE_SIZE = 999

export default {
  name: 'ManageGameTagBatchRelateGameDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    tagData: {
      type: Object,
      default: null,
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance()
    const loading = ref(false)
    const submitLoading = ref(false)
    const relatedLoading = ref(false)

    const searchForm = reactive({
      game_name: '',
      game_provider: '',
    })

    const pagination = reactive({
      currentPage: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      total: 0,
    })

    const fetchedGameList = ref([])
    const relatedRowsRef = ref([]) // 当前标签已关联 gameRow[]
    const pendingRowsRef = ref([]) // 本次新增待提交 gameRow[]
    const leftSelectedKeys = ref([]) // string[]
    const rightSelectedKeys = ref([]) // string[]

    const leftTableRef = ref(null)
    const rightTableRef = ref(null)

    const dialogTitle = computed(() => {
      const tagName = props.tagData?.title ? ` - ${props.tagData.title}` : ''
      return `批量关联游戏${tagName}`
    })

    const formatTagsDisplay = tags => {
      if (!tags) return '-'
      let arr = []
      if (Array.isArray(tags)) {
        arr = tags.map(t => (typeof t === 'object' && t != null && t.title ? t.title : String(t)))
      } else {
        arr = String(tags)
          .split(/[,，、]/)
          .map(s => s.trim())
          .filter(Boolean)
      }
      return arr.length ? arr.join('、') : '-'
    }

    const formatStatus = status => {
      if (status === 1) return '启用'
      if (status === 2) return '禁用'
      return '-'
    }

    const availableRows = computed(() => fetchedGameList.value || [])
    const selectedRows = computed(() => pendingRowsRef.value || [])
    const selectedKeys = computed(() => (pendingRowsRef.value || []).map(gameKey))

    const gameKey = game => String(game?.game_id || game?.id || '')
    const relatedKeySet = computed(() => new Set((relatedRowsRef.value || []).map(gameKey).filter(Boolean)))

    const emitUpdateVisible = val => emit('update:visible', val)

    const isRelatedRow = row => relatedKeySet.value.has(gameKey(row))

    const isSelectableLeftRow = row => !isRelatedRow(row)

    const addSelected = () => {
      const leftKeys = leftSelectedKeys.value || []
      if (!leftKeys.length) return
      const list = availableRows.value || []
      const byKey = new Map(list.map(g => [gameKey(g), g]))
      const exist = new Set((pendingRowsRef.value || []).map(gameKey))
      const next = [...(pendingRowsRef.value || [])]
      leftKeys.forEach(k => {
        const row = byKey.get(k)
        if (row && !exist.has(k)) {
          next.push(row)
          exist.add(k)
        }
      })
      pendingRowsRef.value = next
      leftSelectedKeys.value = []
      leftTableRef.value?.clearSelection?.()
    }

    const removeSelected = () => {
      const rightKeys = rightSelectedKeys.value || []
      if (!rightKeys.length) return
      const removeSet = new Set(rightKeys)
      pendingRowsRef.value = (pendingRowsRef.value || []).filter(row => !removeSet.has(gameKey(row)))
      rightSelectedKeys.value = []
      rightTableRef.value?.clearSelection?.()
    }

    const clearSelected = () => {
      pendingRowsRef.value = []
      leftSelectedKeys.value = []
      rightSelectedKeys.value = []
      leftTableRef.value?.clearSelection?.()
      rightTableRef.value?.clearSelection?.()
    }

    const handleLeftSelectionChange = selection => {
      leftSelectedKeys.value = (selection || []).map(gameKey)
    }

    const handleRightSelectionChange = selection => {
      rightSelectedKeys.value = (selection || []).map(gameKey)
    }

    const loadRelatedGames = async () => {
      if (!props.tagData?.title) {
        relatedRowsRef.value = []
        return
      }

      relatedLoading.value = true
      try {
        const acc = []
        let page = 1
        // 避免极端情况下数据量过大导致卡顿，做一个软上限
        const MAX_ITEMS = 5000
        while (acc.length < MAX_ITEMS) {
          const params = {
            page,
            page_size: RELATED_PAGE_SIZE,
            tags: [props.tagData.title],
          }
          const res = await listGameItems(params)
          if (res.code !== 0) break
          const list = res.data?.list || []
          acc.push(...list)
          if (list.length < RELATED_PAGE_SIZE) break
          page += 1
        }
        relatedRowsRef.value = acc
      } catch (e) {
        relatedRowsRef.value = []
      } finally {
        relatedLoading.value = false
      }
    }

    const loadGames = async () => {
      loading.value = true
      try {
        const params = {
          page: pagination.currentPage,
          page_size: pagination.pageSize,
          tags: [],
          ...searchForm,
        }
        Object.keys(params).forEach(k => {
          if (!params[k]) delete params[k]
        })
        const res = await listGameItems(params)
        if (res.code === 0) {
          fetchedGameList.value = res.data?.list || []
          pagination.total = res.data?.total || 0
        } else {
          fetchedGameList.value = []
          pagination.total = 0
        }
      } catch (e) {
        fetchedGameList.value = []
        pagination.total = 0
      } finally {
        loading.value = false
      }
    }

    const handleSearch = () => {
      pagination.currentPage = 1
      loadGames()
    }

    const handleReset = () => {
      searchForm.game_name = ''
      searchForm.game_provider = ''
      pagination.currentPage = 1
      loadGames()
    }

    const handleSizeChange = size => {
      pagination.pageSize = size
      pagination.currentPage = 1
      loadGames()
    }

    const handleCurrentChange = current => {
      pagination.currentPage = current
      loadGames()
    }

    watch(
      () => props.visible,
      newVal => {
        if (newVal) {
          // 打开时先回填已关联游戏
          loadRelatedGames()
          loadGames()
        }
      }
    )

    watch(
      () => props.tagData,
      newVal => {
        if (props.visible && newVal) {
          // 切换标签时，默认清空上次选择，避免误操作
          clearSelected()
          loadRelatedGames()
          loadGames()
        }
      }
    )

    const handleConfirm = async () => {
      if (!props.tagData?.id) {
        // 兜底：无标签数据不允许提交
        return
      }
      if (!selectedKeys.value.length) {
        proxy.$message.warning('请选择游戏')
        return
      }

      submitLoading.value = true
      try {
        const payload = {
          game_id: selectedKeys.value.map(String),
          tags: String(props.tagData.title),
        }
        const res = await updateGameItemTags(payload)
        if (res.code === 0) {
          emit('save-success')
          emitUpdateVisible(false)
        }
      } catch (e) {
        // request.js 已统一弹错
      } finally {
        submitLoading.value = false
      }
    }

    const handleClosed = () => {
      fetchedGameList.value = []
      relatedRowsRef.value = []
      pendingRowsRef.value = []
      loading.value = false
      submitLoading.value = false
      relatedLoading.value = false
      searchForm.game_name = ''
      searchForm.game_provider = ''
      pagination.currentPage = 1
      pagination.pageSize = DEFAULT_PAGE_SIZE
      pagination.total = 0
      clearSelected()
    }

    return {
      loading,
      submitLoading,
      relatedLoading,
      searchForm,
      dialogTitle,
      emitUpdateVisible,
      handleClosed,
      handleSearch,
      handleReset,
      handleConfirm,
      leftTableRef,
      rightTableRef,
      availableRows,
      selectedRows,
      selectedKeys,
      pagination,
      handleSizeChange,
      handleCurrentChange,
      leftSelectedKeys,
      rightSelectedKeys,
      handleLeftSelectionChange,
      handleRightSelectionChange,
      addSelected,
      removeSelected,
      clearSelected,
      isRelatedRow,
      isSelectableLeftRow,
      formatTagsDisplay,
      formatStatus,
    }
  },
}
</script>

<style scoped>
.dialog-content {
  padding: 10px 0 20px 0;
}

.transfer-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* margin-bottom: 10px; */
}

.tip {
  color: #606266;
  font-size: 12px;
}

.table-transfer {
  display: flex;
  align-items: center;
  gap: 12px;
}

.panel {
  flex: 1 1 0;
  min-width: 0;
}

.panel-title {
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}

.actions {
  flex: 0 0 92px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

.pagination-container {
  margin-top: 12px;
  text-align: right;
}

.right-loading-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}

.game-name-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.related-inline-mark {
  flex: 0 0 auto;
}
</style>
